import { PropsWithChildren } from "react";

import Header from "~/screens/Auth/components/Header";
import { tw } from "~/utils";
import BackButton from "../components/BackButton";
import { Footer } from "../components/Footer";

interface AuthLayoutProps extends PropsWithChildren {
  banner?: React.ReactNode;
  pathToBack?: string;
  bodyClassName?: string;
  buttonClassName?: string;
  canGoBack?: boolean;
  backTo?: string | (() => void);
  showHeader?: boolean;
  showFooter?: boolean;
  showSupport?: boolean;
  showMightyNetworks?: boolean;
  showProtectedByRecaptcha?: boolean;
}

export const AuthLayout = ({
  children,
  banner,
  bodyClassName,
  backTo,
  canGoBack,
  buttonClassName,
  showHeader = true,
  showFooter = true,
  showSupport,
  showMightyNetworks,
  showProtectedByRecaptcha,
}: AuthLayoutProps) => {
  return (
    <main className="flex h-screen w-full flex-col">
      {showHeader && (
        <section>
          <Header />
        </section>
      )}

      <section
        className={tw(
          "flex flex-grow flex-col gap-4 pb-8 md:flex-row md:items-stretch md:gap-10 md:pb-0 md:pt-8",
          bodyClassName,
        )}
      >
        {canGoBack && (
          <div className="px-6 md:hidden">
            <BackButton variant="violet" to={backTo} className="p-0" />
          </div>
        )}

        <section
          className={tw(
            "md:order-0 order-2 flex w-full flex-col items-center px-6 pb-8 xl:px-0",
            !!banner ? "md:w-6/12" : "w-full",
          )}
        >
          <div className="relative flex h-full w-full flex-col">
            <div>
              <div className={tw("hidden md:block", buttonClassName)}>
                {canGoBack && <BackButton variant="violet" to={backTo} />}
              </div>
              <div className="flex grow items-center">
                <div className="w-full">{children}</div>
              </div>
            </div>
          </div>
        </section>

        {banner && (
          <section className="flex w-full items-center justify-center md:max-h-[62dvh] md:w-6/12">
            {banner}
          </section>
        )}
      </section>

      {showFooter && (
        <Footer
          showSupport={showSupport}
          showMightyNetworks={showMightyNetworks}
          showProtectedByRecaptcha={showProtectedByRecaptcha}
        />
      )}
    </main>
  );
};
